import { components, services } from '@/utils'

function renderOperator(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.operator,
        label: this.getTranslate(`${services.dictionaries}.labels.operatorName`),
        service: services.operatorGroups,
        query: {
          DictionaryId: this.dictionary.id,
          $scope: [ 'GroupByOperator' ]
        },
        itemTitle: 'operator',
        itemValue: 'operator',
        dense: true,
        combobox: true,
        setOnBlur: true,
        clearable: true,
        autocomplete: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.operator = event
        }
      }
    }
  )
}
function renderGroup(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.group,
        label: this.getTranslate(`${services.dictionaries}.labels.group`),
        service: services.operatorGroups,
        query: {
          DictionaryId: this.dictionary.id,
          $scope: [ 'GroupByGroup' ]
        },
        itemTitle: 'group',
        itemValue: 'group',
        dense: true,
        combobox: true,
        setOnBlur: true,
        clearable: true,
        autocomplete: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.group = event
        }
      }
    }
  )
}
function renderMCC(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.mcc,
        label: this.getTranslate(`${services.dictionaries}.labels.mcc`),
        dense: true,
        required: true,
        details: false,
        type: 'number',
        step: 'any'
      },
      on: {
        input: event => {
          this.proxy.mcc = event
        }
      }
    }
  )
}
function renderMNC(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.mnc,
        label: this.getTranslate(`${services.dictionaries}.labels.mnc`),
        dense: true,
        required: true,
        details: false,
        type: 'number',
        step: 'any'
      },
      on: {
        input: event => {
          this.proxy.mnc = event
        }
      }
    }
  )
}
export default function(h) {
  return h(
    components.form,
    {
      class: `${services.operatorGroups}-form`,
      on: {
        validation: event => {
          this.$emit('validation', event)
        }
      }
    },
    [
      renderOperator.call(this, h),
      renderGroup.call(this, h),
      renderMCC.call(this, h),
      renderMNC.call(this, h)
    ]
  )
}
